export const MESSAGE = {
  loginSuccess: "Login Successfully",
  deskStatusUpdated: "Desk Saved Successfully",
  customerAssets: "Customer Asset Retrieved Successfully",
};

export const SEVERITY = {
  success: "success",
  error: "error",
  info: "info",
  warning: "warning",
};
